<template>
  <div>
    <!-- Button -->
    <v-btn
      :small="$vuetify.display.xs"
      variant="outlined"
      color="primary"
      @click="reportOptionsDialog = true"
    >
      Report Options
      <v-icon small variant="text" right class="ml-2">
        {{ mdiCog }}
      </v-icon>
    </v-btn>

    <!-- Dialog -->
    <v-dialog v-model="reportOptionsDialog" persistent max-width="700px">
      <v-card>
        <v-card-title class="py-2">
          <v-toolbar-title>Report Options</v-toolbar-title>
          <v-spacer />
          <v-btn variant="text" color="red" class="pa-0 my-0" @click="$emit('reset')">
            Reset
          </v-btn>
          <v-btn
            :icon="mdiClose"
            variant="text"
            class="ma-0 float-end"
            @click="reportOptionsDialog = false"
          />
        </v-card-title>
        <v-card-text>
          <v-container id="report-options-dialog" fluid pa-0>
            <slot />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiClose, mdiCog } from '@mdi/js'

export default {
  emits: ['reset'],
  data: () => ({
    mdiClose,
    mdiCog,
    reportOptionsDialog: false
  })
}
</script>

<style lang="scss">
#report-options-dialog {
  .v-input--switch .v-input__slot {
    margin-bottom: 0;
  }
}
</style>
